var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = require('./der');



//////////////////
// WEBPACK FOOTER
// ./~/asn1.js/lib/asn1/constants/index.js
// module id = 52
// module chunks = 0